



















import ResourceUtils, { Bookshelf } from '@/utils/ResourceUtils';
import { TileBookshelfOptions } from '@/utils/TileUtils';
import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => TileBookshelfOptions,
    },
  },

  computed: {
    bookshelf: {
      get(): Partial<Bookshelf> {
        return this.bookshelfOptions?.find(
          (item: any) => item.value?.id === this.value?.bookshelf?.id
        );
      },
      set(bookshelf: Bookshelf) {
        this.value.bookshelf = { id: bookshelf.id };
      },
    },

    bookshelfOptions(): any {
      return this.bookshelves?.map((bookshelf) => ({
        text: this.$translate(bookshelf.name),
        value: bookshelf,
      }));
    },
  },

  data(): {
    bookshelves?: Bookshelf[];
  } {
    return {
      bookshelves: undefined,
    };
  },

  beforeMount() {
    this.$emit('input', {
      bookshelf: this.value?.bookshelf,
    });
    this.load();
  },

  methods: {
    async load() {
      try {
        this.$alert.hide('load');
        this.bookshelves = await ResourceUtils.api.bookshelf.list();
      } catch (error) {
        this.$alert.show('load', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
